<div *ngIf="isMenuExpanded" class="mt-2 ms-3">
    <div style="min-width: 180px" *ngIf="logoWhite">
        <img src="https://app.skedit.com/content/images/Skedit-Logo-07.png" style="max-width: 150px; max-height: 150px;" />
    </div>
    <div style="min-width: 180px" *ngIf="!logoWhite">
        <img src="https://app.skedit.com/content/images/Skedit-Logo-08.png" style="max-width: 150px; max-height: 150px;" />
    </div>
</div>
<div *ngIf="!isMenuExpanded" style="width:55px">
    <div class="mt-3 ms-3" *ngIf="!logoWhite">
        <img src="https://app.skedit.com/content/images/skedit-icon-black.png" style="max-width: 30px; max-height: 30px;" />
    </div>
    <div class="mt-3 ms-3" *ngIf="logoWhite">
        <img src="https://app.skedit.com/content/images/skedit-icon-gray.png" style="max-width: 30px; max-height: 30px;" />
    </div>
</div>

<div class="sidenav text-light" [ngClass]="{ 'is-open' : isMenuExpanded }" style="background-color: #10253a;">

    <div class="caret">
        <button type="button" (click)="toggleExpanded()"><i class="bi bi-caret-right-fill fa-sm text-light"></i></button>
    </div>

    <button *ngIf="isLathamOrdersOnly && !skeditPay" [routerLink]="['/accessDenied/overview']" class="bg-transparent border-0"><div class="logo"></div></button>
    <button *ngIf="skeditPay" [routerLink]="['/skeditPayTransactionLog']" class="bg-transparent border-0"><div class="skedit-pay-logo"></div></button>


    <!-- MENU ITEMS -->
	<!-- SKEDIT PAY  -->
    <!-- <div class="mainmenu"> -->
    <div class="mainmenu" style="max-height: calc(100vh - 130px);  overflow-y: auto;">
        <div *ngIf="skeditPay">
                <li class="item-accounting">
                    <a style="border-radius:10px" href="/skeditPayTransactionLog"
                    [routerLink]="['/skeditPayTransactionLog']"
                    routerLinkActive="bg-primary text-white">
                        <i class="bi bi-currency-dollar"></i>Transactions
                    </a>
                </li>
                <li *ngIf="isSkeditPayAdmin" class="item-accounting">
                    <a style="border-radius:10px" href="/skeditPayRecurring"
                    [routerLink]="['/skeditPayRecurring']"
                    routerLinkActive="bg-primary text-white">
                        <i class="bi bi-arrow-repeat"></i>Recurring
                    </a>
                    <div *ngIf="showAccountingNotifications && skeditPayRecurringPaymentsErrorCount" class="bg-danger text-white px-2 py-1 side-menu-badge">
                        {{skeditPayRecurringPaymentsErrorCount}}
                    </div>
                </li>
                <li class="item-customers">
                    <a style="border-radius:10px" href="/customers"
                    [routerLink]="['/customers']"
                    routerLinkActive="bg-primary text-white">
                        <i class="bi bi-people-fill"></i>Customers
                    </a>
                </li>

                <li class="item-settings" *ngIf="isSkeditPayAdmin">
                    <a style="border-radius:10px" href="/users" [routerLink]="['/users']"
                    routerLinkActive="bg-primary text-white">
                        <i class="bi bi-person-circle"></i>Users
                    </a>
                </li>

                <li class="item-settings" *ngIf="isSkeditPayAdmin && isQuickbooksEnabled">
                    <a style="border-radius:10px" href="/skeditPayQuickbooksOnline" [routerLink]="['/skeditPayQuickbooksOnline']"
                    routerLinkActive="bg-primary text-white">
                        <i class="bi bi-gear-fill"></i>Quickbooks
                    </a>
                </li>

        </div>


        <!-- NOT SKEDIT PAY  -->
        <!-- HOME -->
        <div *ngIf="!skeditPay">

            <li class="item-home">
                <a (click)="resetHighlight(); checkHighlight('')" href="/home" [routerLink]="['/home']" style="border-radius:10px"
                routerLinkActive="bg-primary text-white">
                    <i class="bi bi-house-fill"></i>Home
                </a>
            </li>

            <!-- SCHEDULE -->
            <li *ngIf="canAccessSchedule" class="item-schedule">
                <a (click)="resetHighlight(); checkHighlight('')" *ngIf="!isLathamOrdersOnly" href='/schedule' [routerLink]="['/schedule']" style="border-radius:10px"
                routerLinkActive="bg-primary text-white">
                    <i class="bi bi-calendar-fill"></i>Schedule
                </a>
                <a (click)="resetHighlight(); checkHighlight('')" *ngIf="isLathamOrdersOnly" href="/accessDenied" [routerLink]="['/accessDenied/schedule']" style="border-radius:10px">
                    <i class="bi bi-calendar-fill"></i>Schedule
                </a>

            </li>

            <!-- CUSTOMERS -->
            <div *ngIf="!isQPro && !isJellyFishTrial">
                <li *ngIf="canAccessCustomers || canAccessCRM || canAccessCustomerMerge" class="item-customers">
                    <input class="toggle" type="checkbox" id="item-customers" [checked]="customersExpanded">
                    <label class="sub-toggle" for="item-customers" style="border-radius:10px" (click)="toggleLocalStorage('Customers');" [ngClass]="{'bg-primary text-white' : highlightCustomers}"><i class="bi bi-people-fill"></i>Customers</label>

                    <ul class="submenu" style="border-radius:10px">
                        <li *ngIf="canAccessCustomers">
                            <a (click)="checkHighlight('/customers')" href="/customers"
                               [routerLink]="['/customers']"
                               routerLinkActive="text-white">
                                Customers
                            </a>
                        </li>

                        <li *ngIf="canAccessCRM">
                            <a (click)="checkHighlight('/crm')" *ngIf="!isLathamOrdersOnly" href="/crm/outreaches" [routerLink]="['/crm/outreaches']"
                               routerLinkActive="text-white" style="border-radius:10px">
                                CRM
                            </a>
                            <a (click)="checkHighlight('/crm')" *ngIf="isLathamOrdersOnly" href="/accessDenied" [routerLink]="['/accessDenied/crm']" style="border-radius:10px">
                                CRM
                            </a>
                        </li>
                        <li *ngIf="canAccessSalesPipeline">
                            <a (click)="checkHighlight('/sales-pipeline')" href="/sales-pipeline" [routerLink]="['/sales-pipeline']"
                            routerLinkActive="text-white" style="border-radius:10px">
                                Sales Pipeline
                            </a>
                        </li>
                        <li *ngIf="canAccessCustomerMerge">
                            <a (click)="checkHighlight('/customer-merge')" href="/customer-merge" [routerLink]="['/customer-merge']"
                            routerLinkActive="text-white">
                                Customer Merge
                            </a>
                        </li>
                    </ul>
                </li>
            </div>


            <div *ngIf="isQPro || isJellyFishTrial">
                <li class="item-customers">
                    <a (click)="resetHighlight(); checkHighlight('')" href='/customers' [routerLink]="['/customers']"
                    routerLinkActive="bg-primary text-white" style="border-radius:10px">
                        <i class="bi bi-people-fill"></i>Customers
                    </a>
                </li>
            </div>

            <li class="item-jobs" *ngIf="isJellyFishTrial">
                <a (click)="checkHighlight('')" href="/jobs" [routerLink]="['/jobs']"
                routerLinkActive="text-white bg-primary" style="border-radius:10px">
                    <i class="bi bi-briefcase-fill"></i>Jobs
                </a>
            </li>


            <!-- JOBS -->
            <li *ngIf="(canAccessJobs || canAccessRecurringJobs || canAccessSmartlist) && !isJellyFishTrial" class="item-jobs">
                <input class="toggle" type="checkbox" id="item-jobs" [checked]="jobsExpanded">
                <label class="sub-toggle" for="item-jobs" style="border-radius:10px" (click)="toggleLocalStorage('Jobs');" [ngClass]="{'bg-primary text-white' : highlightJobs}">
                    <i class="bi bi-briefcase-fill"></i>Jobs
                    <div *ngIf="showJobsNotifications && smartlistOverdueCount" class="bg-danger text-white px-2 py-1 side-menu-badge">
                        {{smartlistOverdueCount}}
                    </div>
                </label>


                <ul class="submenu">
                    <li *ngIf="canAccessJobs">
                        <a (click)="checkHighlight('/jobs')" *ngIf="!isLathamOrdersOnly" href="/jobs" [routerLink]="['/jobs']"
                        routerLinkActive="text-white">
                            Jobs
                        </a>
                        <a (click)="checkHighlight('/jobs')" *ngIf="isLathamOrdersOnly" href="/accessDenied" [routerLink]="['/accessDenied/jobs']">
                            Jobs
                        </a>
                    </li>
                    <li *ngIf="canAccessRecurringJobs">
                        <a (click)="checkHighlight('/jobs')" *ngIf="!isLathamOrdersOnly" href="/recurring" [routerLink]="['/recurring']"
                        routerLinkActive="text-white">
                            Recurring
                        </a>
                        <a (click)="checkHighlight('/jobs')" *ngIf="isLathamOrdersOnly" href="/accessDenied" [routerLink]="['/accessDenied/recurring']">
                            Recurring
                        </a>
                    </li>
                    <li *ngIf="canAccessSmartlist">
                        <a (click)="checkHighlight('/jobs')" *ngIf="!isLathamOrdersOnly" href="/smartlist" [routerLink]="['/smartlist']"
                        routerLinkActive="text-white">
                            <div style="position: relative">
                                Smartlist
                                <div *ngIf="showJobsNotifications && smartlistOverdueCount" class="bg-danger text-white px-2 py-1 sub-menu-badge">
                                    {{smartlistOverdueCount}}
                                </div>
                            </div>
                        </a>
                        <a (click)="checkHighlight('/jobs')" *ngIf="isLathamOrdersOnly" href="/accessDenied" [routerLink]="['/accessDenied/smartlist']">
                            <div style="position: relative">
                                Smartlist
                                <div *ngIf="showJobsNotifications && smartlistOverdueCount" class="bg-danger text-white px-2 py-1 sub-menu-badge">
                                    {{smartlistOverdueCount}}
                                </div>
                            </div>
                        </a>
                    </li>
                </ul>
            </li>

            <!-- ACCOUNTING -->
            <div *ngIf="!isQPro">
                <li *ngIf="canAccessEstimates || canAccessSalesOrders || canAccessInvoices || canAccessPOS || canAccessPayments || canAccessQuickbooks || canAccessLathamBillBatch" class="item-accounting">
                    <input class="toggle" type="checkbox" id="item-accounting" [checked]="accountingExpanded">
                    <label class="sub-toggle" for="item-accounting" style="border-radius:10px" (click)="toggleLocalStorage('Accounting');" [ngClass]="{'bg-primary text-white' : highlightAccounting}">
                        <i class="bi bi-currency-dollar"></i>Accounting
                        <div *ngIf="showAccountingNotifications && recurringBillingErrorCount" class="bg-danger text-white px-2 py-1 side-menu-badge">
                            {{recurringBillingErrorCount}}
                        </div>
                    </label>

                    <ul class="submenu">
                        <li>
                            <a (click)="checkHighlight('/leads')" href="/leads"
                               [routerLink]="['/leads']"
                               routerLinkActive="text-white">
                                Leads
                            </a>
                        </li>
                        <li *ngIf="canAccessEstimates">
                            <a (click)="checkHighlight('/estimates')" href="/estimates" [routerLink]="['/estimates']"
                               routerLinkActive="text-white">
                                Quotes
                            </a>
                            <!--<a *ngIf="isLathamOrdersOnly" href="/accessDenied" [routerLink]="['/accessDenied']">
            <i class="far fa-calculator"></i>Estimates
        </a>-->
                        </li>
                        <li *ngIf="canAccessSalesOrders">
                            <a (click)="checkHighlight('/salesOrders')" href="/salesOrders" [routerLink]="['/salesOrders']"
                               routerLinkActive="text-white">
                                Sales Orders
                            </a>
                            <!--<a *ngIf="isLathamOrdersOnly" href="/accessDenied" [routerLink]="['/accessDenied']">
            <i class="far fa-dollar-sign"></i>Sales Orders
        </a>-->
                        </li>
                        <li *ngIf="canAccessInvoices">
                            <a (click)="checkHighlight('/invoices')" href="/invoices" [routerLink]="['/invoices']"
                               routerLinkActive="text-white">
                                Invoices
                            </a>
                            <!--<a *ngIf="isLathamOrdersOnly" href="/accessDenied" [routerLink]="['/accessDenied']">
            <i class="far fa-file-invoice-dollar"></i>Invoices
        </a>-->
                        </li>
                        <li *ngIf="canAccessLathamBillBatch">
                            <a (click)="checkHighlight('/lathamOrders/billBatch')" href="/lathamOrders/billBatch" [routerLink]="['/lathamOrders/billBatch']"
                            routerLinkActive="text-white">
                                Batch Latham POs
                            </a>
                        </li>
                        <li *ngIf="canAccessPOS">
                            <a (click)="checkHighlight('/pos')" href="/pos" [routerLink]="['/pos']"
                               routerLinkActive="text-white">
                                POS
                            </a>
                        </li>
                        <li *ngIf="canAccessPayments">
                            <a (click)="checkHighlight('/payments')" href="/payments" [routerLink]="['/payments']"
                               routerLinkActive="text-white">
                                Payments
                            </a>
                            <!--<a *ngIf="isLathamOrdersOnly" href="/accessDenied" [routerLink]="['/accessDenied']">
            <i class="far fa-credit-card"></i>Payments
        </a>-->
                        </li>
                        <li *ngIf="!isJellyFishTrial">
                            <a (click)="checkHighlight('/recurring-billing')" href="/recurring-billing" [routerLink]="['/recurring-billing']"
                               routerLinkActive="text-white">

                                <div style="position: relative">
                                    Recurring Billing
                                    <div *ngIf="showAccountingNotifications && recurringBillingErrorCount" class="bg-danger text-white px-2 py-1 sub-menu-badge">
                                        {{recurringBillingErrorCount}}
                                    </div>
                                </div>

                            </a>

                            <!--<a *ngIf="isLathamOrdersOnly" href="/accessDenied" [routerLink]="['/accessDenied']">
            <i class="far fa-credit-card"></i>Payments
        </a>-->
                        </li>
                        <li *ngIf="canAccessQuickbooks">
                            <a (click)="checkHighlight('/quickbooks')" href="/quickbooks" [routerLink]="['/quickbooks']"
                               routerLinkActive="text-white">
                                <div>
                                    <span class="quickbooks-text">Quickbooks</span>
                                </div>
                            </a>
                        </li>
                    </ul>
                </li>
            </div>

            <!-- JellyFish Orders-->
            <!--<li *ngIf="useJellyFishOrdering || isJellyFish" class="item-latham-orders">
                <a (click)="resetHighlight(); checkHighlight('');" href="/jellyFishOrders" [routerLink]="['/jellyFishOrders']"
                routerLinkActive="bg-primary" style="border-radius:10px">
                    <div class="d-flex align-items-center">
                        <div class="flex-fill">
                            <i><img src="../../../content/images/jelly-fish-logo-white.png" style="max-width: 20px; max-height: 20px;" /></i>JellyFish Orders
                        </div>
                        <div class="mr-1">
                            <div *ngIf="isJellyFish && jellyFishUnapprovedOrdersCount" class="bg-danger text-white px-2 py-1 side-menu-badge">
                                {{jellyFishUnapprovedOrdersCount}}
                            </div>
                        </div>
                    </div>
                </a>
            </li>-->


            <!-- LATHAM ORDERS -->
            <li *ngIf="canAccessLathamOrders" class="item-latham-orders">
                <a (click)="resetHighlight(); checkHighlight('');" href="/lathamOrders" [routerLink]="['/lathamOrders']"
                   routerLinkActive="bg-primary" style="border-radius:10px">
                    <div class="d-flex align-items-center">
                        <div class="flex-fill">
                            <i *ngIf="!isPavinTheWay && mizuOrdering"><img src="../../../content/images/Mizu-Logo-Simbol-white (4).png" style="max-width: 15px; max-height: 15px;" /></i>
                            <i *ngIf="!isPavinTheWay && !mizuOrdering"><img src="../../../content/images/latham-logo-white.png" style="max-width: 15px; max-height: 15px;" /></i>
                            <i *ngIf="isPavinTheWay" class="bi bi-cart"></i>
                            <span *ngIf="!isPavinTheWay && mizuOrdering">Mizu Orders</span>
                            <span *ngIf="!isPavinTheWay && !mizuOrdering">Latham Orders</span>
                            <span style="font-size:.95rem; margin-left:-5px" *ngIf="isPavinTheWay">Coverstar Central</span>
                        </div>
                        <div class="me-1">
                            <div *ngIf="showLathamOrdersNotifications && totalOrdersCount" class="bg-danger text-white px-2 py-1 side-menu-badge">
                                {{totalOrdersCount}}
                            </div>
                        </div>
                    </div>
                </a>
            </li>

            <!-- INVENTORY -->
            <li *ngIf="canAccessInventory && canAccessPartsList" class="item-inventory">
                <input class="toggle" type="checkbox" id="item-inventory" [checked]="inventoryExpanded">
                <label class="sub-toggle" for="item-inventory" style="border-radius:10px" (click)="toggleLocalStorage('Inventory');" [ngClass]="{'bg-primary text-white' : highlightInventory}"><i class="bi bi-box-seam-fill"></i>Inventory</label>

                <ul class="submenu">
                    <li *ngIf="canAccessInventory">
                        <a (click)="checkHighlight('/inventory')" href="/inventory" [routerLink]="['/inventory']"
                        routerLinkActive="text-white">
                            Inventory
                        </a>
                    </li>
                    <li *ngIf="canAccessPartsList">
                        <a (click)="checkHighlight('/items')" href="/items" [routerLink]="['/items']"
                        routerLinkActive="text-white">
                            Parts List
                        </a>
                    </li>
                    <li *ngIf="canAccessInventory && canAccessPickList">
                        <a (click)="checkHighlight('/pickList')" href="/pickList" [routerLink]="['/pickList']"
                        routerLinkActive="text-white">
                            Pick List
                        </a>
                    </li>
                </ul>
            </li>

            <li *ngIf="canAccessInventory && !canAccessPartsList" class="item-inventory" id="item-inventory">
                <a style="border-radius:10px" (click)="resetHighlight(); checkHighlight('')" href="/inventory" [routerLink]="['/inventory']"
                routerLinkActive="bg-primary text-white">
                    <i class="bi bi-box-seam-fill"></i>Inventory
                </a>
            </li>

            <li *ngIf="canAccessPartsList && !canAccessInventory" class="item-inventory" id="item-inventory">
                <a style="border-radius:10px" (click)="resetHighlight(); checkHighlight('')" href="/items" [routerLink]="['/items']"
                routerLinkActive="bg-primary text-white">
                    <i class="bi bi-tools"></i>Parts List
                </a>
            </li>

            <!-- Purchasing -->
            <li class="item-purchasing" *ngIf="canAccessVendors || canAccessPurchaseOrders || canAccessReceiving">
                <input class="toggle" type="checkbox" id="item-purchasing" [checked]="purchasingExpanded">
                <label class="sub-toggle" for="item-purchasing" style="border-radius:10px" (click)="toggleLocalStorage('Purchasing');" [ngClass]="{'bg-primary text-white' : highlightPurchasing}"><i class="bi bi-cart-fill"></i>Purchasing</label>

                <ul class="submenu">
                    <li *ngIf="canAccessVendors">
                        <a (click)="checkHighlight('/vendors')" href="/vendors"
                        [routerLink]="['/vendors']"
                        routerLinkActive="text-white">
                            Vendors
                        </a>
                    </li>

                    <li *ngIf="canAccessPurchaseOrders">
                        <a (click)="checkHighlight('/purchaseOrders')" href="/purchaseOrders" [routerLink]="['/purchaseOrders']"
                        routerLinkActive="text-white">
                            Purchase Orders
                        </a>
                    </li>

                    <li *ngIf="canAccessReceiving">
                        <a (click)="checkHighlight('/receiving')" href="/receiving" [routerLink]="['/receiving']"
                        routerLinkActive="text-white">
                            Receiving
                        </a>
                    </li>

                </ul>
            </li>

            <li class="item-purchasing" *ngIf="canAccessShipping && !isLathamOrdersOnly">
                <a (click)="resetHighlight(); checkHighlight('')" href="/shipping" [routerLink]="['/shipping']"
                routerLinkActive="bg-primary text-white" style="border-radius:10px">
                    <i class="fas fa-truck"></i>Shipping
                </a>
            </li>

            <!-- TextChat -->
            <li *ngIf="canAccessTextChat" class="item-text-chat">
                <a (click)="resetHighlight(); checkHighlight('')" href='/textChat'
                [routerLink]="['/textChat']"
                routerLinkActive="bg-primary text-white" style="border-radius:10px">

                    <div class="d-flex align-items-center">
                        <div class="flex-fill">
                            <i class="bi bi-chat-square-text-fill"></i>Text Chat
                        </div>
                        <div class="me-1">
                            <div *ngIf="showTextChatNotifications && textChatUnreadMessagesCount > 0" class="bg-danger text-white px-2 py-1 side-menu-badge">
                                {{textChatUnreadMessagesCount}}
                            </div>
                        </div>
                    </div>
                </a>
            </li>

            <!-- Timeclock -->
            <li *ngIf="!isJellyFishTrial" class="item-timeclock">
                <a (click)="resetHighlight(); checkHighlight('')" *ngIf="!isLathamOrdersOnly" href='/timeclock' [routerLink]="['/timeclock']"
                routerLinkActive="bg-primary text-white" style="border-radius:10px">
                    <i class="bi bi-clock-fill"></i>Time Clock
                </a>
                <a (click)="resetHighlight(); checkHighlight('')" *ngIf="isLathamOrdersOnly" href="/accessDenied" [routerLink]="['/accessDenied/timeclock']" style="border-radius:10px">
                    <i class="bi bi-clock-fill"></i>Time Clock
                </a>
            </li>

            <!-- Documents -->
            <li *ngIf="canAccessDocuments" class="item-documents">
                <a (click)="resetHighlight(); checkHighlight('')" *ngIf="!isLathamOrdersOnly" href='/documents' [routerLink]="['/documents']"
                routerLinkActive="bg-primary text-white" style="border-radius:10px">
                    <i class="bi bi-file-earmark-text-fill"></i>Documents
                </a>
                <a (click)="resetHighlight(); checkHighlight('')" *ngIf="isLathamOrdersOnly" href="/accessDenied" [routerLink]="['/accessDenied/documents']" style="border-radius:10px">
                    <i class="bi bi-file-earmark-text-fill"></i>Documents
                </a>
            </li>
            

            <!-- CLAIMS -->
            <li *ngIf="isMizu" class="item-claims">
                <input class="toggle" type="checkbox" id="item-claims" [checked]="claimsExpanded">
                <label class="sub-toggle" for="item-claims" style="border-radius:10px" (click)="toggleLocalStorage('Claims');" [ngClass]="{'bg-primary text-white' : highlightClaims}">
                    <i class="bi bi-shield-fill-check"></i>Claims
                    <div *ngIf="rmaNewClaimsCount" class="bg-danger text-white px-2 py-1 side-menu-badge">
                        {{rmaNewClaimsCount}}
                    </div>
                </label>

                <ul class="submenu">
                    <li>
                        <a (click)="openNewSubmission()" style="cursor: pointer;">
                            New Submission
                        </a>
                    </li>
                    <li *ngIf="canAccessClaimsCenter">
                        <a (click)="checkHighlight('/claims-center')" href="/claims-center"
                        [routerLink]="['/claims-center']"
                        routerLinkActive="text-white">
                            Claims Center
                        </a>
                    </li>
                    <li *ngIf="canAccessRmaTracker">
                        <a (click)="checkHighlight('/rma-tracker')" href="/rma-tracker"
                        [routerLink]="['/rma-tracker']"
                        routerLinkActive="text-white">
                            <div style="position: relative">
                                Claim Tracker
                                <div *ngIf="rmaNewClaimsCount" class="bg-danger text-white px-2 py-1 sub-menu-badge">
                                    {{rmaNewClaimsCount}}
                                </div>
                            </div>
                        </a>
                    </li>
                </ul>
            </li>

            <!-- Reports -->
            <li *ngIf="canAccessReports && !isJellyFishTrial" class="item-reports">
                <!--<input class="toggle" type="checkbox" id="item-reports" [checked]="reportsExpanded">
                <label class="sub-toggle" for="item-reports" style="border-radius:10px" (click)="toggleLocalStorage('Reports');" [ngClass]="{'bg-primary text-white' : highlightReports}"><i class="bi bi-bar-chart-fill"></i>Reports</label>-->

                <a (click)="resetHighlight(); checkHighlight('/reporting');" href='/reporting/reports-list'
                   [routerLink]="['/reporting/reports-list']"
                   routerLinkActive="bg-primary text-white" style="border-radius:10px">
                    <i class="bi bi-bar-chart-fill"></i>Reports
                </a>
            
            <!--  <ul class="submenu">
                    <li>
                        <a (click)="checkHighlight('/reporting')" style="margin:0px;" *ngIf="!isLathamOrdersOnly" href='/reporting/apptAveragesReport'
                           [routerLink]="['/reporting/apptAveragesReport']"
                           routerLinkActive="text-white">
                            Appt Averages Report
                        </a>
                        <a (click)="checkHighlight('/reporting')" style="margin:0px;" *ngIf="isLathamOrdersOnly" href="/accessDenied" [routerLink]="['/accessDenied/apptAveragesReport']">
                            Appt Averages Report
                        </a>
                    </li>
                    <li>
                        <a (click)="checkHighlight('/reporting')" style="margin:0px;" *ngIf="!isLathamOrdersOnly" href='/reporting/itemUsageReport'
                           [routerLink]="['/reporting/itemUsageReport']"
                           routerLinkActive="text-white">
                            Item Usage Report
                        </a>
                        <a (click)="checkHighlight('/reporting')" style="margin:0px;" *ngIf="isLathamOrdersOnly" href="/accessDenied" [routerLink]="['/accessDenied/itemUsageReport']">
                            Item Usage Report
                        </a>
                    </li>

                    <li *ngIf="isCanada || isIMPC">
                        <a (click)="checkHighlight('/reporting')" style="margin:0px;" href='/reporting/itemUsageByBuilderReport'
                           [routerLink]="['/reporting/itemUsageByBuilderReport']"
                           routerLinkActive="text-white">
                            Item Usage By Builder
                        </a>
                    </li>

                    <li *ngIf="isCanada">
                        <a (click)="checkHighlight('/reporting')" style="margin:0px;" href='/reporting/cscPartsListReport'
                           [routerLink]="['/reporting/cscPartsListReport']"
                           routerLinkActive="text-white">
                            CSC Parts List Report
                        </a>
                    </li>

                    <li *ngIf="canAccessLathamOrders">
                        <a (click)="checkHighlight('/reporting')" style="margin:0px;" href='/reporting/lathamOrderInsights'
                           [routerLink]="['/reporting/lathamOrderInsights']"
                           routerLinkActive="text-white">
                            Latham Insights Report
                        </a>
                    </li>

                    <li *ngIf="isIMPC">
                        <a (click)="checkHighlight('/reporting')" style="margin:0px;" href='/reporting/lathamShipping'
                           [routerLink]="['/reporting/lathamShipping']"
                           routerLinkActive="text-white">
                            Latham Shipping Report
                        </a>
                    </li>

                    <li *ngIf="isCanada">
                        <a (click)="checkHighlight('/reporting')" style="margin:0px;" href='/reporting/lathamReport'
                           [routerLink]="['/reporting/lathamReport']"
                           routerLinkActive="text-white">
                            Latham Report
                        </a>
                    </li>
                    <li *ngIf="isCanada">
                        <a (click)="checkHighlight('/reporting')" style="margin:0px;" href='/reporting/rebatesReport'
                           [routerLink]="['/reporting/rebatesReport']"
                           routerLinkActive="text-white">
                            Rebates Report
                        </a>
                    </li>
                    <li>
                        <a (click)="checkHighlight('/reporting')" style="margin:0px;" *ngIf="!isLathamOrdersOnly" href='/reporting/resourceApptTypesReport'
                           [routerLink]="['/reporting/resourceApptTypesReport']"
                           routerLinkActive="text-white">
                            Resource Appt Types
                        </a>
                        <a (click)="checkHighlight('/reporting')" style="margin:0px;" *ngIf="isLathamOrdersOnly" href="/accessDenied" [routerLink]="['/accessDenied/resourceApptTypesReport']">
                            Resource Appt Types
                        </a>
                    </li>
                    <li *ngIf="isCanada">
                        <a (click)="checkHighlight('/reporting')" style="margin:0px;" href='/reporting/ontarioBuilderReport'
                           [routerLink]="['/reporting/ontarioBuilderReport']"
                           routerLinkActive="text-white">
                            Ontario Builder Report
                        </a>
                    </li>
                    <li *ngIf="isCanada">
                        <a (click)="checkHighlight('/reporting')" style="margin:0px;" href='/reporting/lathamSystemSummaryReport'
                           [routerLink]="['/reporting/lathamSystemSummaryReport']"
                           routerLinkActive="text-white">
                            System Summary Report
                        </a>
                    </li>
                    <li>
                        <a (click)="checkHighlight('/reporting')" style="margin:0px;" href='/reporting/employeeApptsReport'
                           [routerLink]="['/reporting/employeeApptsReport']"
                           routerLinkActive="text-white">
                            Employee Appts Report
                        </a>
                    </li>
                    <li>
                        <a (click)="checkHighlight('/reporting')" style="margin:0px;" href='/reporting/employeeAvgHoursWorked'
                           [routerLink]="['/reporting/employeeAvgHoursWorked']"
                           routerLinkActive="text-white">
                            Employee Avg Hours
                        </a>
                    </li>
                    <li>
                        <a (click)="checkHighlight('/reporting')" style="margin:0px;" href='/reporting/employeeMonthlyHoursWorked'
                           [routerLink]="['/reporting/employeeMonthlyHoursWorked']"
                           routerLinkActive="text-white">
                            Employee Monthly Hours
                        </a>
                    </li>
                    <li>
                        <a (click)="checkHighlight('/reporting')" style="margin:0px;" href='/reporting/employeeYearlyHoursWorked'
                           [routerLink]="['/reporting/employeeYearlyHoursWorked']"
                           routerLinkActive="text-white">
                            Employee Yearly Hours
                        </a>
                    </li>

                    <li *ngIf="useQuoteTracking">
                        <a (click)="checkHighlight('/reporting')" style="margin:0px;" href='/reporting/quoteTracking'
                           [routerLink]="['/reporting/quoteTracking']"
                           routerLinkActive="text-white">
                            Quote Tracking
                        </a>
                    </li>
                </ul>-->
            </li>

            <!-- Users -->
            <li *ngIf="canAccessUsers" class="item-documents">
                <a *ngIf="!isLathamOrdersOnly" (click)="checkHighlight('/users')" href="/users" [routerLink]="['/users']"
                    routerLinkActive="bg-primary text-white" style="border-radius:10px">
                    <i class="bi bi-person-fill"></i>Users
                </a>
                <a *ngIf="isLathamOrdersOnly" (click)="resetHighlight(); checkHighlight('')" href="/accessDenied" [routerLink]="['/accessDenied/users']" style="border-radius:10px">
                    <i class="bi bi-person-fill"></i>Users
                </a>
            </li>

            <!-- Settings -->
            <li *ngIf="canAccessSettings" class="item-documents" style="position: absolute; bottom: 0px; width: 175px;">
                <a *ngIf="!isLathamOrdersOnly" (click)="openSettings()" style="cursor: pointer; border-radius:10px">
                    <i class="bi bi-gear-fill"></i><span style="margin-left: 3px;">Settings</span>
                </a>
                <a *ngIf="isLathamOrdersOnly" (click)="resetHighlight(); checkHighlight('')" href="/accessDenied" [routerLink]="['/accessDenied/users']" style="border-radius:10px">
                    <i class="bi bi-gear-fill"></i><span style="margin-left: 3px;">Settings</span>
                </a>
            </li>
              
            <div [ngClass]="{'settings-overlay': true, 'show': isSettingsOpen, 'hide': !isSettingsOpen}">
                <div class="settings-content">
                  <button class="close-button" (click)="closeSettings()">&times;</button>
                    <h1 style="border-bottom: 1px solid black; margin-bottom: 0rem; padding-bottom: 3px;">Settings</h1>
                  <router-outlet *ngIf="isSettingsOpen"></router-outlet> 
                </div>
            </div>
    </div>

    <!-- Email Logs -->
    <li *ngIf="canAccessEmailLog" class="item-text-email">
        <a (click)="resetHighlight(); checkHighlight('')" href='/emailLog'
           [routerLink]="['/emailLog']"
           routerLinkActive="bg-primary text-white" style="border-radius:10px">
            <i class="bi bi-envelope-fill"></i>Communication
        </a>
    </li>

     <!-- SETTINGS -->
     <!-- <li *ngIf="canAccessSettings || canAccessUsers" class="item-settings">
        <input class="toggle" type="checkbox" id="item-settings" [checked]="settingsExpanded">
        <label class="sub-toggle" for="item-settings" style="border-radius:10px" (click)="toggleLocalStorage('Settings');" [ngClass]="{'bg-primary text-white' : highlightSettings}"><i class="bi bi-gear-fill"></i>Settings</label>

        <ul class="submenu">
            <li *ngIf="canAccessSettings">
                <a (click)="checkHighlight('/settings')" href="/settings" [routerLink]="['/settings']"
                   routerLinkActive="text-white">
                    Settings
                </a>
            </li>
            <li *ngIf="canAccessUsers">
                <a (click)="checkHighlight('/users')" href="/users" [routerLink]="['/users']"
                   routerLinkActive="text-white">
                    Users
                </a>
            </li>
        </ul>
    </li> -->
</div>
<!-- In-app New Submission dialog: hosts the claim submission form in embedded mode -->
<slick-dialog #newSubmissionDialog header="New Submission" [width]="1000" (onClose)="onNewSubmissionClosed()">
    <!-- The form is created here on demand by openNewSubmission() and cleared on close. Declaring
         it in the template instead would make LayoutModule import it eagerly into main.js. -->
    <ng-container #newSubmissionHost></ng-container>
</slick-dialog>
